import React, { useEffect, useState } from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";
import "./educationSection.css";
import { getSchoolKey, getDegreeDict } from "../../../helpers/stringHelper";

const EducationSection = ({ userId }) => {
  const [educationHistory, setEducationHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEducationHistory = async () => {
      try {
        const response = await fetch(
          `/api/attorney/webapp/fetchEducationData?userId=${encodeURIComponent(
            userId
          )}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch education history");
        }

        const data = await response.json();
        setEducationHistory(data);
      } catch (error) {
        console.error("Error fetching education history:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchEducationHistory();
    }
  }, [userId]);

  if (loading) {
    return <div className="education-section-loading">Loading...</div>;
  }

  return (
    <div className="education-section-container">
      <div className="work-education-container">
        <p className="education-section-title">Education Experience</p>
        <Timeline
          align="left"
          sx={{
            "& .MuiTimelineItem-root:before": {
              flex: 0,
            },
          }}
        >
          {educationHistory && educationHistory.length > 0 ? (
            educationHistory.map((item) => {
              const { id, institution, degree, start_year, end_year, primary } =
                item;

              // Format the date range
              const dateRange = `${start_year} – ${end_year}`;

              return (
                <TimelineItem key={id}>
                  <TimelineSeparator>
                    <TimelineDot color={primary ? "primary" : "grey"} />
                    <div className="timeline-line" />
                  </TimelineSeparator>
                  <TimelineContent>
                    <div className="education-section-job-item">
                      <p className="education-section-year-range">
                        {dateRange}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "left",
                          marginLeft: "auto",
                          width: "60%",
                        }}
                      >
                        <p className="education-section-college">
                          {getSchoolKey(institution)}
                        </p>
                        <p className="education-section-description">
                          {getDegreeDict(degree)}
                        </p>
                      </div>
                    </div>
                  </TimelineContent>
                </TimelineItem>
              );
            })
          ) : (
            // Render a placeholder timeline item if no education history is available
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot color="grey" />
                <div className="timeline-line" />
              </TimelineSeparator>
              <TimelineContent>
                <div className="education-section-job-item">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                      marginLeft: "auto",
                      width: "60%",
                    }}
                  >
                    <p className="education-section-college">
                      No educational background found.
                    </p>
                    <p className="education-section-description">
                      {/* Optionally add more placeholder text here */}
                    </p>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
          )}
        </Timeline>
      </div>
    </div>
  );
};

export default EducationSection;
